<template>
  <div class="hero-banner show-on-load" :class="classes">
    <base-image
      :mobile-url="fields.heroMobile?.value?.src"
      :tablet-url="fields.heroTablet?.value?.src"
      :desktop-url="fields.heroDesktop?.value?.src"
      :desktop-alt="fields.heroDesktop?.value?.alt"
      :tablet-alt="fields.heroTablet?.value?.alt"
      :mobile-alt="fields.heroMobile?.value?.alt"
      :full-width="true"
      fetchpriority="high"
    />
    <div v-if="fields.title?.value || $isPageEditing" class="container">
      <sc-text :tag="params.headingType ?? 'h1'" :field="fields.title" class="hero-banner__title" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import BaseImage from '../2_elements/BaseImage/BaseImage.vue';
import { Text as ScText } from '@sitecore-jss/sitecore-jss-vue';
import type { HeroBannerProps } from './types';

const props = withDefaults(defineProps<HeroBannerProps>(), {
  fields: () => ({}),
  params: () => ({}),
});

const classes = computed(() => [
  props.params.backgroundOverlay === '1' && 'hero-banner--bg-overlay',
  props.params.dynamicHeight === '1' && 'hero-banner--dynamic-height',
]);
</script>

<style lang="scss">
@import './scss/HeroBanner.scss';
</style>
